module.exports = __webpack_public_path__ + "static/media/cv.b32ba6b1.svg";